module.exports = __webpack_public_path__ + "img/Molecule_to_G.39abe348.gif";